import React, { useEffect, useRef, useState } from 'react';
import { CLUBS } from '../../service/hubClubLogos';
import backstories from './clubBackstories';

export default function ClubCarousel({ stories = backstories }) {
  const [active, setActive] = useState(null);
  const [position, setPosition] = useState({});
  const timer = useRef(null);
  const root = useRef(null);
  const cancelClose = () => clearTimeout(timer.current);
  const closeSoon = () => { cancelClose(); timer.current = setTimeout(() => setActive(null), 150); };
  const show = (club, target) => {
    cancelClose();
    const rect = target.getBoundingClientRect();
    const width = Math.min(340, window.innerWidth - 24);
    const below = window.innerHeight - rect.bottom - 20;
    setPosition({ width, left: Math.max(12, Math.min(window.innerWidth - width - 12, rect.left + rect.width / 2 - width / 2)), ...(below >= 180 ? { top: rect.bottom + 12, maxHeight: Math.min(360, below) } : { bottom: window.innerHeight - rect.top + 12, maxHeight: Math.max(100, rect.top - 24) }) });
    setActive(club);
  };
  useEffect(() => {
    const dismiss = event => { if (!root.current?.contains(event.target)) setActive(null); };
    const escape = event => { if (event.key === 'Escape') setActive(null); };
    const resize = () => setActive(null);
    document.addEventListener('pointerdown', dismiss);
    document.addEventListener('keydown', escape);
    window.addEventListener('resize', resize);
    return () => { clearTimeout(timer.current); document.removeEventListener('pointerdown', dismiss); document.removeEventListener('keydown', escape); window.removeEventListener('resize', resize); };
  }, []);
  return <div className="club-carousel" ref={root} onMouseEnter={cancelClose} onMouseLeave={closeSoon}>
    <div className="crest-strip" aria-label="Clubs in The Open League">
      <div className="crest-track" data-paused={Boolean(active)}>{[0, 1].map(copy => <div className="crest-set" key={copy} aria-hidden={copy === 1 ? true : undefined}>{CLUBS.map(club => <button className="crest-button" type="button" key={club.code} tabIndex={copy === 1 ? -1 : 0} aria-label={club.name} aria-describedby={active?.code === club.code ? 'club-backstory' : undefined} onMouseEnter={event => show(club, event.currentTarget)} onFocus={event => show(club, event.currentTarget)} onBlur={closeSoon} onClick={event => show(club, event.currentTarget)}><img src={club.src} alt="" /></button>)}</div>)}</div>
    </div>
    {active && <aside id="club-backstory" role="tooltip" className="club-story" style={position} onMouseEnter={cancelClose}>
      <div className="club-story-heading"><img src={active.src} alt="" /><div><span>Club backstory</span><h3>{active.name}</h3></div></div>
      <p>{stories[active.code] || 'This club’s backstory is not available yet.'}</p>
    </aside>}
  </div>;
}
